// Don't modify structue, only add data.

// import avatar from "../assets/team/avatar.png";
import avatar2 from "../assets/team/qirail_logo.png";

import viji from "../assets/team/Viji.jpeg";
import amal from "../assets/team/amal.jpg";
import julia from "../assets/team/julia.jpeg";
import sharon from "../assets/team/sharon.jpeg";

export const alumniData = [
    {
        name: "Vijay Shree G",
        designation: "Clinical Sociologist",
        department: "Radiation Oncology",
        image: viji,
        // about: "",
        email: "",
        linkedin: ""
    },
    {
        name: "Dr Julia Priyadarshini Rao",
        designation: 'Clinical Research Fellow',
        from: "Radiation Oncology",
        image: julia,
    },
    {
        name: "Amal Joseph Varghese",
        designation: "Project Assistant",
        from: "Radiation Oncology",
        image: amal,
        linkedin: "https://www.linkedin.com/in/amaljova/"
    },
    {
        name: "Sharon Gikku George",
        about: "Physiotherapist",
        from: "Radiation Oncology",
        image: sharon,
        designation: 'Research Coordinator',
    },
    {
        name: 'Ramya Vepuri',
        designation: 'Project Assistant',
        from: 'Radiation Oncology',
        image: avatar2,
        linkedin: "https://www.linkedin.com/in/ramya-sree-vepuri-811a81169/"
    },
    {
        name: 'Arathy Roy',
        designation: 'Intern',
        from: 'VIT University',
        image: avatar2
    },
    {
        name: 'Vimal Nair',
        designation: 'Intern',
        from: 'VIT University',
        image: avatar2
    },
    {
        name: 'Sreeram Sreekumar',
        designation: 'Intern',
        from: 'VIT University',
        image: avatar2
    }
]